<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal=false
    :close-on-press-escape=false
    width="700px"
    @close="handleClose"
  >
    <el-form :model="formObj" :rules="rules"  ref="formRef" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="机构" prop="organCodes">
            <el-cascader
                v-model="formObj.organCodes"
                :options="orgList"
                :show-all-levels="false"
                :props="cascaderProps"
                clearable
                placeholder="请选择机构"
                @change="handleChange"
                @getCheckedNodes="checkedNodesEvent"
              >
              </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="姓名" prop="agentName">
            <el-input v-model="formObj.agentName" placeholder="请输入姓名" maxlength="20"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="PE号码" prop="agentCode">
            <el-input v-model="formObj.agentCode" maxlength="10"  placeholder="请输入PE号码"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户角色" prop="agentRoles">
            <el-select v-model="formObj.agentRoles" multiple placeholder="请选择用户角色">
              <el-option
                v-for="(item,index) in allRoleList"
                :key="index"
                :label="item.enumName"
                :value="item.enumCode"
                />
            </el-select>
            
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="状态" prop="enable">
            <el-radio-group v-model="formObj.enable">
              <el-radio border :label="true">启用</el-radio>
              <el-radio border :label="false">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="时间范围" prop="dateRange">
            <el-date-picker
              v-model="formObj.dateRange"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="截至"
              :picker-options="pickerOptions"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
       
      </el-row>
  
      <div class="btns">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
  
<script>
import url from "@/modules/url";
import api from "@/modules/api";
export default {
  data() {
    return {
      rules: {
        organCodes:[
          { required: true, message: '请选择机构', trigger: 'change'},
        ],
        agentName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { 
            pattern: /^[\u4e00-\u9fa5\·]*$/,
            message: '只能输入汉字', 
            trigger: 'blur'
          }
        ],
        agentCode: [
          { required: true, message: '请输入PE号码', trigger: 'blur' },
          { 
            pattern: /^[A-Za-z0-9]{1,10}$/, 
            message: '只能输入字母和数字，且不超过10位', 
            trigger: 'blur'
          }
        ],
        agentRoles: [
          { required: true, message: '请选择用户角色', trigger: 'change' },
        ],
        enable: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        dateRange: [
          { required: true, message: '时间范围', trigger: 'change' }
        ]
      },
      dialogVisible: true, // 控制对话框的显示与隐藏
      cascaderProps: {
        multiple: true,
        checkStrictly: true,
        value: 'code',   // 指定 value 字段
        label: 'name',   // 指定 label 字段
        children: 'childList' // 指定 children 字段
      },
      allRoleList: this.roleList,
      formObj: {
        organCodes: '', // 机构编码
        agentName: '', // 姓名
        agentCode:'', // PE号码
        agentRoles: [], // 用户角色
        enable: true, // 状态
        dateRange: [], // 时间范围
        fromDate: '',
        toDate: ''
      },
      manageComNameOptions: [], // 存储机构下拉菜单数据的集合
      pickerOptions: {
        disabledDate(time) {
          let selectedDay = time.getFullYear() + String(time.getMonth() + 1).padStart(2, "0") + String(time.getDate()).padStart(2, "0")
          let nowDate = new Date();
          let nowDay = nowDate.getFullYear() + String(nowDate.getMonth() + 1).padStart(2, "0") + String(nowDate.getDate()).padStart(2, "0")
          console.log(selectedDay, nowDay)
          return selectedDay < nowDay; // 禁用今天之前的日期
        },
      },
    };
  },
  props: {
    title:{
      type: String,
      default: '新增'
    },
    formData: {
      type: [String, Object],
      default: ''
    },
    orgList: {
      type: Array,
      default: []
    },
    roleList: {
      type: Array,
      default: []
    },
  },
  mounted () {
  },
  watch: {
    'formData': function (val) {
      if(val.id) {
        this.makeFormData(val)
      }
    }
  },
  methods: {
    makeFormData(data) {
      this.formObj = {
        id: data.id,
        organCodes: data.organCodesList, // 机构编码
        agentName: data.agentName,
        agentCode:data.agentCode,
        enable: data.enable,
        agentRoles: [],
        dateRange: [data.fromDate,data.toDate]
      }
      console.log(data.roleList,'roleList=====')
      if (data.roleList && data.roleList.length > 0) {
        data.roleList.forEach(element => {
          this.formObj.agentRoles.push(element);
        });
      }
      console.log(this.formObj,'formData=====')
    },
    // 提交表单
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const { dateRange } = this.formObj
          this.formObj.fromDate= dateRange[0] || ''
          this.formObj.toDate= dateRange[1] || ''
          this.save(this.formObj)
          console.log('表单数据',this.formObj);
        } else {
          return false;
        }
      });
    },
    save(data){
      api.post(url.saveAccountAgent, data, (res) => {
        if (res.result.isSuccess) {
          this.handleClose(); 
          console.log(res.result,'提交成功');
        } else {
          if (res.result.errors.length > 0) {
            this.$message(
              res.result.errors[0].errorCode + res.result.errors[0].error
            );
          } else {
            this.$message(res.result.error);
          }
        }
      });
    },
    handleClose() {
      this.formObj = {
        organCodes: [],
        agentName: '',
        agentCode:'',
        agentRoles: [],
        enable: '',
        dateRange: [],
        fromDate: '',
        toDate: ''
      };
      this.$emit('close'); 
      this.$emit('refresh')
    },
    handleChange(val) {
      console.log(val,'机构')
    },
    checkedNodesEvent(node){
      console.log(node,'list')
    }
  }
};
</script>

<style lang="scss" scoped>
.btns {
  text-align: center;
}
.el-radio {
  margin-right: 10px!important;
}

</style>


// WEBPACK FOOTER //
// src/pages/recruit/userManagement/component/editDialog.vue